import React, { useRef, useEffect } from 'react';

export interface IScrollToFirstErrorProps {
  container: HTMLElement | null;
  isSubmitting: boolean;
}

export const ScrollToFirstError: React.FC<IScrollToFirstErrorProps> = ({ container, isSubmitting }) => {
  const prevRef = useRef<boolean>(isSubmitting);
  useEffect(() => {
    if (prevRef.current === isSubmitting) {
      return;
    }

    if (prevRef.current && !isSubmitting) {
      const elements = container?.querySelectorAll('[data-class=form-cell-error]');
      elements?.[0]?.scrollIntoView({ behavior: 'instant', block: 'center' });
    }
    prevRef.current = isSubmitting;
  }, [container, isSubmitting]);
  return <></>;
};
